import { useState } from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { GALLERY, IMAGES } from "../data/site";
import { Dialog, DialogContent } from "../components/ui/dialog";

export default function Gallery() {
  const [active, setActive] = useState(null);
  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow="Gallery" title={["Kerala, frame", "by frame."]}
        subtitle="A glimpse of the landscapes and moments that await you across God's Own Country." image={IMAGES.backwaterBoat} />
      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 py-24">
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
          {GALLERY.map((src, i) => (
            <Reveal key={i} delay={(i % 4) * 0.05}>
              <button onClick={() => setActive(src)} className="block w-full overflow-hidden group" data-testid={`gallery-img-${i}`}>
                <img src={src} alt="Kerala" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </button>
            </Reveal>
          ))}
        </div>
      </section>
      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent className="max-w-4xl bg-transparent border-0 p-0" data-testid="gallery-lightbox">
          {active && <img src={active} alt="Kerala" className="w-full h-auto" />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
